/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DnR API
 * 地方自治体事業管理システムAPI
 * OpenAPI spec version: 1.0.0
 */

/**
 * ステータス
 */
export type ProjectReferenceMatchDetailResponseStatus =
  (typeof ProjectReferenceMatchDetailResponseStatus)[keyof typeof ProjectReferenceMatchDetailResponseStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProjectReferenceMatchDetailResponseStatus = {
  idle: 'idle',
  pending: 'pending',
  generating: 'generating',
  completed: 'completed',
  failed: 'failed',
  deleted: 'deleted',
} as const;
